import React, { useEffect, useState } from 'react';
import ApiProvider from '../../../core/api/ApiProvider';
// @ts-ignore
import styles from './CustomerTransactions.module.scss';
import Status from '../../../core/types/Status';
import { DataTableHeader } from '../../../core/components/Table/types/DataTableHeader';
import { DataTable } from '../../../core/components/Table/types/DataTable';
import { CustomerTransaction } from './types/CustomerTransaction';
import DateTimeParser from '../../../core/utils/DateTimeParser';
import { Button, Loader, ModuleContainer, Table } from '../../../core/components';
import { TranslationService } from '../../../core/services';
import withAbortRequest, { AbortRequestPropsType } from '../../../core/hoc/withAbortRequest';
import { Link, useHistory } from 'react-router-dom';
import { AppContext } from '../../../AppContext';

const CustomerTransactions = (props: AbortRequestPropsType) => {
  const context = React.useContext(AppContext);
  const history = useHistory();
  const [tableRows, setTableRows] = useState<any[]>([]);
  const [tableHeaders, setTableHeaders] = useState<DataTableHeader[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchCases = async () => {
    try {
      const result = await ApiProvider.get<Status<DataTable<CustomerTransaction>>>(
        'CustomerTransactionsModule/GetCustomersTransactions',
        props.cancelTokenSource.token
      );

      if (result.success) {
        const headers = result.data.headers.map((h) => {
          h.cssClassNames = `${!h.isVisible && 'hide-d'} ${!h.isVisibleOnMobile && 'hide-m'}`;

          h.isSortColumn = true;

          if (h.columnName === 'InvoiceNo') {
            h.cssClassNames = `featured`;
            h.formatter = (value: string, row: CustomerTransaction) => {
              return (
                <Link
                  to={`TransactionDetails/${row.InvoiceNo}/${row.CreditorNo}/${row.AccountNo}/${row.DebtorNo}`}
                >
                  {value}
                </Link>
              );
            };
          }
          if (h.columnName === 'CaseNo') {
            h.cssClassNames = `featured`;
            h.formatter = (value: any, row: CustomerTransaction) => {
              return <Link to={`CaseDetails/${row.CaseNo}`}>{row.CaseNo}</Link>;
            };
          }
          if (h.columnName === 'RegDate') {
            h.formatter = (value: any) => {
              return DateTimeParser.toLocaleDateString(value);
            };
          }

          if (h.columnName === 'Capital') {
            h.cssClassNames = 'to-right';
          }

          if (h.columnName === 'Balance') {
            h.cssClassNames = 'to-right';
          }

          return h;
        });

        headers.push({
          columnName: 'Actions',
          cssClassNames: '',
          headerName: '',
          isButtonColumn: false,
          isColumnId: true,
          isDocumentLink: false,
          isSortColumn: false,
          isVisible: true,
          isVisibleOnMobile: true,
          sortColumnNumber: 0,
          formatter: (value: any, row: any) => (
            <div>
              <Button
                variant={Button.Variants.Primary}
                size={Button.Sizes.SM}
                type={Button.Types.Button}
                isUppercase
                onClick={() => {
                  history.push(
                    `TransactionDetails/${row.InvoiceNo}/${row.CreditorNo}/${row.AccountNo}/${row.DebtorNo}`
                  );
                }}
              >
                {TranslationService.translate('CaseList_ViewButtonLabel')}
              </Button>
            </div>
          ),
        });

        const rows = result.data.dataRows.map((r) => {
          return {
            ...r,
            RegDate: DateTimeParser.toValueOf(r.RegDate),
          };
        });

        if (!context.isHideMypageCases) {
          setTableRows(rows);
        }

        setTableHeaders(headers);
      }
    } catch (error) {}
  };

  // @ts-ignore
  useEffect(() => {
    let isSubscribed = true;

    (async () => {
      await fetchCases();

      if (isSubscribed) {
        setIsLoading(false);
      }
    })();

    return () => (isSubscribed = false);
  }, []);

  return (
    <ModuleContainer classNames={styles.wrapper}>
      <ModuleContainer.Header
        id="InvoicesTab"
        classNames={styles.header}
        title={TranslationService.translate('Invoices')}
        headingLevel="h2"
      />

      <ModuleContainer.Body>
        {isLoading && <Loader opacity={0.4} />}
        <Table
          headers={tableHeaders}
          rows={tableRows}
          keyField="InvoiceNo"
          wrapperClassNames="has-h-scrollbar"
          paginationProps={{
            hideSizePerPage: true,
            hidePageListOnlyOnePage: true,
          }}
        />
      </ModuleContainer.Body>
    </ModuleContainer>
  );
};

export default withAbortRequest(CustomerTransactions);
